import React, { useEffect, useRef, useState } from 'react';
import * as rsuite from 'rsuite';

import Layout from '../../Layout/PrintLayout';
import * as General from '../General/General';
import { trackPromise } from 'react-promise-tracker';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import * as BiIcon from "react-icons/bi";
import GetTax from '../Common/GetTax';
import PN from "persian-number";


const PrintPreFactorIndex = () => {

    //#region Const
    const navigate = useNavigate();
    const GetTaxRef = useRef()
    const toaster = rsuite.useToaster();
    const [ItemList, setItemList] = useState([]);
    const [RecieptList, setRecieptList] = useState([]);
    const [HeaderId, setHeaderId] = useState(localStorage.getItem("PreFactorHeaderId"));
    const [Tax, setTax] = useState(0);
    const [Code, setCode] = useState("");
    const [HeaderPrice, setHeaderPrice] = useState(0);
    const [TotalReciept, setTotalReciept] = useState(0);
    const [HeaderDiscount, setHeaderDiscount] = useState(0);
    const [HeaderTax, setHeaderTax] = useState(0);
    const [FreightPrice, setFreightPrice] = useState(0);
    const [ReadOnlyRegisterDate, setReadOnlyRegisterDate] = useState("");
    const [Customer, setCustomer] = useState("");
    const [FinancialBalance, setFinancialBalance] = useState("");
    const [Mobile, setMobile] = useState("");
    const [Address, setAddress] = useState("");
    const [Comment, setComment] = useState("");

    //#region Methods


    const GetById = () => {
        trackPromise(
            fetch(General.ApiRoute() + '/PreFactor/GetHeaderById', {
                method: 'Get',
                headers: {
                    'ApiKey': General.APIKey(),
                    'Id': localStorage.getItem("PreFactorHeaderId")
                },
                credentials: 'include'
            })
                .then(res => res.json())
                .then(result => {
                    setReadOnlyRegisterDate(result.registerDate)
                    setHeaderPrice(result.totalPrice);
                    setTotalReciept(result.totalReciept);
                    setCode(result.code);
                    setCustomer(result.customer)
                    if (result.hasFactor == 1)
                        setFinancialBalance(result.financialBalance)
                    else
                        setFinancialBalance(result.financialBalance * 1 - result.totalPrice * 1 + result.totalReciept * 1)

                    setMobile(result.mobile)
                    setAddress(result.city + " - " + result.address)
                    setComment(result.comment)
                    setFreightPrice(result.freightPrice)
                    setHeaderTax(result.itemTax);
                    setHeaderDiscount(result.discountPrice * 1 + result.itemDiscountPrice * 1);
                    var tmp = [];
                    var Paytmp = [];


                    if (result.children.length > 0) {


                        for (var i = 0; i < result.children.length; i++) {
                            tmp.push({
                                row: i + 1,
                                price: PN.sliceNumber(result.children[i].price),
                                tax: PN.sliceNumber(result.children[i].tax),
                                totalPrice: PN.sliceNumber(result.children[i].totalPrice),
                                discountPrice: PN.sliceNumber(result.children[i].discountPrice),
                                count: result.children[i].count,
                                product: result.children[i].product,

                            })
                        }
                        setItemList(tmp)
                        console.dir(result.reciepts)

                        for (var i = 0; i < result.preReciepts.length; i++) {
                            Paytmp.push({
                                row: i + 1,
                                Id: result.preReciepts[i].id,
                                RefId: result.preReciepts[i].refId,
                                Id: result.preReciepts[i].id,
                                Price: result.preReciepts[i].price,
                                PayType: result.preReciepts[i].payType,
                                PayDate: result.preReciepts[i].payDate == null ? "" : result.preReciepts[i].payDate,
                                PayTime: result.preReciepts[i].payTime,
                                RecieptNo: result.preReciepts[i].recieptNo,
                                CheckNo: result.preReciepts[i].checkNo,
                                CheckDate: result.preReciepts[i].checkDate == null ? "" : result.preReciepts[i].checkDate,
                                Branch: result.preReciepts[i].branch,
                                Bank: result.preReciepts[i].bank,
                                Comment: result.preReciepts[i].comment,
                                POS: result.preReciepts[i].pos,
                                BankAccount: result.preReciepts[i].bankAccount,
                                Fund: result.preReciepts[i].fund,
                                ConfirmCheck: result.preReciepts[i].confirmCheck,

                            })
                        }
                        setRecieptList(Paytmp);

                    }

                })
        )
    }





    const CheckPermission = () => {
        var myHeaders = new Headers();
        myHeaders.append("ApiKey", General.APIKey());
        myHeaders.append("Page", 21);
        myHeaders.append("Operation", 0);

        var requestOptions = {
            method: "Get",
            headers: myHeaders,
            credentials: 'include'

        };
        trackPromise(
            fetch(General.ApiRoute() + "/Common/CheckPermission", requestOptions)
                .then(response => response.text())
                .then(result => {
                    if (result.toString() != "OK") {
                        navigate("/AccessDenied");
                    }
                    else {
                        GetById();
                        GetTaxRef.current.Get();
                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')
                })
        )
    }

    useEffect(() => {
        CheckPermission();
        document.title = "چاپ پیش فاکتور ";
        const inputElement = document.querySelector('.FocusItem');
        if (inputElement) {
            inputElement.focus();
        }
    }, [])
    //#endregion



    return (

        <Layout title="پیش فاکتور">

            <GetTax ref={GetTaxRef} onSubmit={(value) => setTax(value)} />

            <rsuite.Row className='p-1'>
                <rsuite.Col xxl={16} xl={16} lg={16} md={16} sm={12} xs={12}>
                    <b>شماره پیش فاکتور:   </b>{Code}
                </rsuite.Col>
                <rsuite.Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={12}>
                    <b> تاریخ:   </b> {ReadOnlyRegisterDate}

                </rsuite.Col>
                <rsuite.Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={12}>
                    <b>شماره همراه مشتری:   </b> {Mobile}
                </rsuite.Col>
                <rsuite.Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={12}>
                    <b> نام و نام خانوادگی:   </b> {Customer}
                </rsuite.Col>

                <rsuite.Col className={Address != '' ? "" : "hide"} xxl={16} xl={16} lg={16} md={16} sm={24} xs={24}>
                    <b> آدرس:   </b>
                    {Address}
                </rsuite.Col>
                <rsuite.Col className={Comment != '' ? "" : "hide"} xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                    <b> توضیحات:  </b> {Comment}
                </rsuite.Col>

            </rsuite.Row>
            <hr />

            <div className={localStorage.getItem("FontSize_PreFactorPrint") + " p-1 "}>

                <table class="table table-sm">
                    <thead>
                        <tr>
                            <th>
                                #
                            </th>
                            <th>
                                محصول
                            </th>
                            <th className='text-center'>
                                تعداد
                            </th>
                            <th className='text-center'>
                                قیمت
                            </th>
                            <th className={ItemList.findIndex(x => x.discountPrice != 0) != -1 ? 'text-center' : 'hide'}>
                                تخفیف
                            </th>
                            <th className={Tax == 0 ? 'hide' : 'text-center'}>
                                مالیات
                            </th>
                            <th className='text-center'>
                                قیمت کل
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {ItemList.map(item => (
                            <tr>
                                <td>{item.row}</td>
                                <td>{item.product}</td>
                                <td className='text-center'>{item.count}</td>
                                <td className='text-center'>{item.price}</td>
                                <td className={ItemList.findIndex(x => x.discountPrice != 0) == -1 ? 'hide' : 'text-center'}>{item.discountPrice}</td>
                                <td className={Tax == 0 ? 'hide' : 'text-center'}>{item.tax}</td>
                                <td className='text-center'>{item.totalPrice}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>

            </div>
            <div className={ItemList.length>10 ? '' : 'hide'} style={{"page-break-before": "always"}} />
            <rsuite.Row className={localStorage.getItem("FinancialFontSize_PreFactorPrint") + " p-1 "}>
                <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className={RecieptList.length > 0 && localStorage.getItem("PreRecieptDetail_ShowInPreFactorPrint") == "1" ? 'ps-2' : "hide"}>
                    <rsuite.Divider> مشخصات مالی پیش فاکتور</rsuite.Divider>
                    <rsuite.Row>
                        <rsuite.Col className={HeaderDiscount == 0 ? "hide" : "mt-1"} xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} >
                            <b>تخفیف کل : </b> {PN.sliceNumber(HeaderDiscount)} ریال
                            {/* &nbsp;&nbsp;&nbsp;&nbsp;<rsuite.Text className='Font10' as='sub'>{HeaderDiscount != "0" ? <>{PN.convert(HeaderDiscount)} ریال</> : ""}</rsuite.Text> */}
                        </rsuite.Col>
                        <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className={Tax == 0 ? "hide" : "mt-1"} >
                            <b>مالیات کل : </b> {PN.sliceNumber(HeaderTax)} ریال
                            {/* &nbsp;&nbsp;&nbsp;&nbsp;<rsuite.Text className='Font10' as='sub'>{HeaderTax != "0" ? <>{PN.convert(HeaderTax)} ریال</> : ""}</rsuite.Text> */}
                        </rsuite.Col>
                        <rsuite.Col className={localStorage.getItem("FreightPrice_ShowInPreFactorPrint") == "0" || FreightPrice == 0 ? "hide" : "mt-1"} xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}  >
                            <b> کرایه : </b> {PN.sliceNumber(FreightPrice)} ریال
                            {/* &nbsp;&nbsp;&nbsp;&nbsp;<rsuite.Text className='Font10' as='sub'>{FreightPrice != "0" ? <>{PN.convert(FreightPrice)} ریال</> : ""}</rsuite.Text> */}
                        </rsuite.Col>
                        <rsuite.Col className={HeaderDiscount == 0 || localStorage.getItem("TotalPriceBeforDiscount_ShowInPreFactorPrint") == "0" ? "hide" : "mt-1"} xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} >
                            <b>مبلغ قبل از تخفیف : </b> <text>  {PN.sliceNumber(HeaderPrice * 1 + HeaderDiscount * 1)} ریال </text>
                            {/* &nbsp;&nbsp;&nbsp;&nbsp;<rsuite.Text className='Font10' as='sub'>{HeaderPrice != "0" ? <>{PN.convert(HeaderPrice * 1 + HeaderDiscount * 1)} ریال</> : ""}</rsuite.Text> */}

                        </rsuite.Col>
                        <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className=' mt-1'>
                            <b>مبلغ قابل پرداخت : </b> <text>  {PN.sliceNumber(HeaderPrice)} ریال </text>
                            {/* &nbsp;&nbsp;&nbsp;&nbsp;<rsuite.Text className='Font10' as='sub'>{HeaderPrice != "0" ? <>{PN.convert(HeaderPrice)} ریال</> : ""}</rsuite.Text> */}
                        </rsuite.Col>
                        <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className='mt-1'>
                            <b>مبلغ پرداختی : </b> <text>  {PN.sliceNumber(TotalReciept)} ریال </text>
                            {/* &nbsp;&nbsp;&nbsp;&nbsp;<rsuite.Text className='Font10' as='sub'>{TotalReciept != "0" ? <>{PN.convert(TotalReciept)} ریال</> : ""}</rsuite.Text> */}
                        </rsuite.Col>
                        <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className='mt-1'>
                            <b>مبلغ باقیمانده : </b> <text>  {PN.sliceNumber(HeaderPrice - TotalReciept)} ریال </text>
                            {/* &nbsp;&nbsp;&nbsp;&nbsp;<rsuite.Text className='Font10' as='sub'>{HeaderPrice - TotalReciept != "0" ? <>{PN.convert(HeaderPrice - TotalReciept)} ریال</> : ""}</rsuite.Text> */}
                        </rsuite.Col>
                    </rsuite.Row>
                </rsuite.Col>
                <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className={RecieptList.length > 0 && localStorage.getItem("PreRecieptDetail_ShowInPreFactorPrint") == "1" ? 'ps-2' : "hide"}>
                    <rsuite.Row>
                        <rsuite.Divider>جزییات پرداخت</rsuite.Divider>
                        {RecieptList.map(pay => (

                            <rsuite.Col className={"mt-1"} xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} >
                                {pay.PayType == 2 ? <b> کارت خوان  - {pay.POS}  </b> :
                                    pay.PayType == 4 ? <b> حواله بین بانکی -  {pay.BankAccount}  </b> :
                                        pay.PayType == 3 ? <b> کارت به کارت -  {pay.BankAccount}  </b> :
                                            pay.PayType == 1 ? <b> نقدی -  {pay.Fund}  </b> :
                                                <b> چک -   شماره چک : {pay.CheckNo} - تاریخ سر رسید : {pay.checkDate}  </b>
                                } : {PN.sliceNumber(pay.Price)} ریال
                                {/* &nbsp;&nbsp;&nbsp;&nbsp;<rsuite.Text className='Font10' as='sub'>{PN.convert(pay.Price)} ریال</rsuite.Text> */}

                            </rsuite.Col>
                        ))}



                    </rsuite.Row>

                </rsuite.Col>
                <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className='mt-2' >
                    <hr />
                    <b> باقیمانده حساب با احتساب مانده از قبل :</b>

                    {FinancialBalance > 0 ?
                        <text className='text-success ' > {PN.sliceNumber(FinancialBalance)} ریال بستانکار
                            &nbsp;&nbsp;&nbsp;&nbsp;<rsuite.Text color='green' className='Font10' as='sub'>{PN.convert(FinancialBalance.toString().replaceAll(',', ''))} ریال</rsuite.Text>
                        </text>
                        : FinancialBalance < 0 ?
                            <text className='text-danger'> {PN.sliceNumber(FinancialBalance * (-1))} ریال بدهکار
                                &nbsp;&nbsp;&nbsp;&nbsp;<rsuite.Text color='red' className='Font10' as='sub'>{PN.convert((FinancialBalance * (-1)).toString().replaceAll(',', ''))} ریال</rsuite.Text>
                            </text>

                            :
                            " 0 ریال"}
                </rsuite.Col>
            </rsuite.Row>

            <hr />
            <rsuite.Row className={localStorage.getItem("CommentFontSize_PreFactorPrint") + ' p-1  pt-3 mt-3 pb-5 mb-5 '}>
                <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                    <div dangerouslySetInnerHTML={{ __html: localStorage.getItem("footer_PreFactorPrint").replaceAll(/\//g, '<br/>') }} />

                </rsuite.Col>
                <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className='text-center'  >
                    <br />
                    <br />
                    امضا فروشنده
                    :{localStorage.getItem("UserFullName")}

                </rsuite.Col>
                <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className='text-center'  >
                    <br />
                    <br />
                    امضا خریدار
                    :{Customer}
                </rsuite.Col>


            </rsuite.Row>
        </Layout >


    )
}

export default PrintPreFactorIndex;